import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IListResource, ListReducer } from "../../types/redux.types";
import { AppResource } from "../../types/resource.types";

interface ISetNotification {
  resource: AppResource;
  hasNotification?: boolean;
}

const initialState: ListReducer = {};
const initialResourceState: IListResource = {
  hasNotification: false,
  counter: 0,
  decrementalCounter: Number.MAX_SAFE_INTEGER,
};

const listSlice = createSlice({
  name: "@__list",
  initialState,
  reducers: {
    updateList(state: ListReducer, action: PayloadAction<ListReducer>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setResourceNotification(state: ListReducer, action: PayloadAction<ISetNotification>) {
      const { resource, hasNotification = false } = action.payload;
      state[resource] = {
        ...(state[resource] || initialResourceState),
        hasNotification,
        counter: state[resource] && state[resource].counter >= 0 ? state[resource].counter + 1 : 0,
      };
    },
    resetListNotification(state: ListReducer, action: PayloadAction<string>) {
      state[action.payload] = initialResourceState;
    },
    decrementNotificationCounter(state: ListReducer, action: PayloadAction<ISetNotification>) {
      const { resource } = action.payload;
      state[resource] = {
        ...(state[resource] || initialResourceState),
        decrementalCounter: state[resource].decrementalCounter - 1,
      };
    },
  },
});

export const { updateList, decrementNotificationCounter, setResourceNotification, resetListNotification } =
  listSlice.actions;
export default listSlice.reducer;
